import classNames from 'classnames'
import { ReactNode } from 'react'
import { HEADER_DEFAULT_X_PADDING_STYLES } from './Header'

interface IProps {
  classes?: string
  topPadding?: string
  children: ReactNode
}

export const LayoutXPaddingWrapper = ({ classes, children }: IProps) => (
  <div className={classNames(classes, HEADER_DEFAULT_X_PADDING_STYLES)}>{children}</div>
)
